/* eslint-disable no-undef */
import React, { FC } from 'react';

import { Stack, StackProps } from 'Modules/ui3';

import { CFALogo } from '../../icons/cfa';


interface CfaHubIconProps extends StackProps {
    dark?: boolean;
    size?: number;
    borderRadius?: number;
}

export const CfaHubIcon: FC<CfaHubIconProps> = ({
    dark, size = 12, borderRadius = 4, ...props
}) => (
    <Stack
        justifyContent='center'
        alignItems='center'
        bgcolor={dark ? 'rgba(255, 255, 255, 0.08)' : 'general.primary50'}
        height={({ spacing }) => spacing(size)}
        width={({ spacing }) => spacing(size)}
        borderRadius={borderRadius}
        {...props}
        sx={{
            transition: 'background-color 0.3s',
            '&>svg': {
                height: ({ spacing }) => spacing(size / 2),
                width: '100%',
            },
        }}
    >
        <CFALogo />
    </Stack>
);
